/** Creator slice lookup only; SDK validates the supplied canonical endpoint names. */
export const PILOT_ENDPOINTS = Object.freeze([
  Object.freeze({
    slice: "efficientReduxAPI",
    endpoint: "getCreatorConfig",
    name: "getcreatorconfig",
  }),
  Object.freeze({
    slice: "reduxAPI",
    endpoint: "getCreatorData",
    name: "getcreatordata",
  }),
]);
export const RELEASE_2_ENDPOINTS = Object.freeze([
  ...PILOT_ENDPOINTS.map((endpoint) =>
    Object.freeze({ ...endpoint, owner: "home" })
  ),
  Object.freeze({
    slice: "reduxAPI",
    endpoint: "postSingleProductLink",
    name: "postsingleproductlink",
    owner: "diy_single_product",
  }),
  Object.freeze({
    slice: "reduxAPI",
    endpoint: "getScrapingFailureDomains",
    name: "getscrapingfailuredomains",
    owner: "diy_single_product",
  }),
]);
export const apiRegistry = Object.freeze({
  lookup: (slice: string, endpoint: string) =>
    RELEASE_2_ENDPOINTS.find(
      (entry) => entry.slice === slice && entry.endpoint === endpoint
    )?.name,
});
export const API_NAMES = Object.freeze(
  RELEASE_2_ENDPOINTS.map((entry) => entry.name)
);
